<template>
  <div class="row justify-content-center">
    <div class="col-xs-12 col-sm-8 col-md-8 col-lg-6 pl-lg-0">
      <h4 class="text-center my-3">
        {{ vehicle.year }}
        {{ vehicle.make }}
        {{ vehicle.model }}
      </h4>
      <div class="vehicle-media-slides-wrap">
        <flickity ref="flickity" :options="flickityOptions">
          <div class="vehicle-slide" v-for="(photo, index) in vehiclePhotos" :key="index">
            <figure class="m-0">
              <img :src="photo" alt="media-offer-description" />
            </figure>
          </div>
        </flickity>
        <div class="item-count">
          {{ currentSlide }} of
          {{ vehiclePhotos.length }}
        </div>
        <div class="mobile-swipe-icon">
          <img src="/img/icons/swipe-icon.svg" alt="swipe-icon" />
        </div>
      </div>
      <base-accordion title="Basic Information">
        <basic-information :vehicle="vehicle" :vendor="vendor" />
      </base-accordion>
      <base-accordion title="Specifications" ref="accordion">
        <specifications
          :aliases="specificationsAliases"
          :equipments="vehicleEquipments"
          :list="['interior', 'exterior', 'safety', 'mechanical']"
        />
      </base-accordion>
    </div>
  </div>
</template>

<script>
import BaseAccordion from '@/components/base-accordion';
import BasicInformation from '@/components/vehicle-card/basic-information';
import Specifications from '@/components/vehicle-card/specifications';

export default {
  name: 'VehicleCard',
  components: {
    BaseAccordion,
    BasicInformation,
    Specifications,
  },
  props: {
    photoSize: {
      type: String,
      default: 'med',
    },
    vehicle: {
      type: Object,
      required: true,
    },
    vendor: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      currentSlide: 1,
      flickityOptions: {
        initialIndex: 0,
        prevNextButtons: true,
        pageDots: false,
        wrapAround: false,
        fullscreen: true,
      },
      specificationsAliases: {
        safety: 'security',
        tech_specs: 'tech specs',
      },
      vehicleData: null,
    };
  },
  computed: {
    vehicleEquipments() {
      const vehicleEquipments = {};

      Object.keys(this.vehicle.equipments).forEach(
        (category) =>
          (vehicleEquipments[category] = this.vehicle.equipments[category].map(
            (equipment) => equipment.description
          ))
      );

      return vehicleEquipments;
    },
    vehiclePhotos() {
      return this.vehicle.photos[this.photoSize];
    },
  },
  mounted() {
    this.$refs.flickity.on('change', (index) => {
      this.currentSlide = index + 1;
    });
  },
};
</script>

<style>
.flickity-enabled.is-fullscreen .vehicle-slide {
  height: 100%;
}

.vehicle-media-slides-wrap {
  overflow-y: hidden;
}

.mobile-swipe-icon {
  background: #000000dd;
  bottom: 0;
  position: absolute;
  height: 70px;
  width: 70px;
  z-index: 100;
  left: 50%;
  transform: translate(-50%, 50%);
  border-radius: 100%;
}

.mobile-swipe-icon img {
  height: 25px;
  width: 25px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -100%);
}

@media (max-width: 478px) {
  .flickity-enabled.is-fullscreen .vehicle-slide {
    height: 50%;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
  }

  .flickity-button.flickity-prev-next-button {
    display: none;
  }
}

.flickity-enabled.is-fullscreen {
  z-index: 10000 !important;
}

.item-count {
  background: #000000dd;
  color: white;
  padding: 0.25rem 1rem;
  position: absolute;
  font-size: 0.75rem;
  border-radius: 3px;
  left: 5px;
  bottom: 5px;
}

.spec-title {
  font-size: 1rem;
  font-weight: bold;
  margin-bottom: 0.5rem;
}

.specs-list {
  padding: 0;
}

.equipment-item {
  list-style: none;
  font-size: 14px;
  margin-bottom: 0.4rem;
  background-image: url('/img/icons/check-black.svg');
  background-repeat: no-repeat;
  background-position: 11px 2px;
  padding-left: 31px;
}

.btn-more {
  padding: 5px 5px;
  border: 3px solid #007bff !important;
  transform: scale(0.6);
  margin: auto;
  border-radius: 100%;
  position: relative;
}

.btn-more i {
  transform: translate(-50%, -50%) scale(1.5);
  color: #007bff;
  position: absolute;
  top: 50%;
  left: 50%;
}

.basic-info-second-row h4 {
  font-size: 1rem;
  font-weight: bold;
  margin-bottom: 0.5rem;
}

.basic-info-second-row h4 span {
  font-size: 1rem;
  font-weight: normal;
  display: block;
}
</style>
